import { useQuery, useMutation } from '@tanstack/react-query';
import {
  IChangelog,
  IChangelogViewTrackingEvent,
} from '../../Interfaces/IChangelog';
import { customFetcher } from '../useFetch';

export const useGetChangelog = () => {
  const {
    data: changelog,
    isLoading: isLoadingChangelog,
    refetch: refetchChangelog,
  } = useQuery<IChangelog>({
    queryKey: ['changelog'],
    queryFn: () =>
      customFetcher({
        endpoint: `/changelog`,
      }),
  });

  return { changelog, isLoadingChangelog, refetchChangelog };
};

export const useTrackReleaseView = () => {
  const {
    mutateAsync: trackReleaseView,
    isPending: isPendingTrackReleaseView,
  } = useMutation({
    mutationFn: (changelogViewTrackingEvent: IChangelogViewTrackingEvent) =>
      customFetcher({
        endpoint: '/changelog/track-view',
        method: 'POST',
        body: changelogViewTrackingEvent,
      }),
  });

  return { trackReleaseView, isPendingTrackReleaseView };
};
